
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__color__/[slug]",
      function () {
        return require("private-next-pages/__color__/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__color__/[slug]"])
      });
    }
  